<section class="main-container" (scroll)="onScroll($event)">
    <table class="scroll-container mat-elevation-z8" mat-table [dataSource]="dataSource">
        @for (column of displayedColumns; track column) {
            <ng-container
                [matColumnDef]="column.key"
                [sticky]="isSticky(column.key)">
                <th mat-header-cell *matHeaderCellDef>
                    <div class="center no-wrap">
                        @switch (column.filterType) {
                            @case ('custom') {
                                <div>
                                    @switch (column.key) {
                                        @case ('projectName') {
                                            <mat-form-field class="flex">
                                                <mat-label class="flex center no-wrap">{{ column.label }}</mat-label>
                                                <mat-select [formControl]="filter.projectNames"
                                                            (selectionChange)="onProjectChange()"
                                                            multiple>
                                                    @for (project of getProject(); track project) {
                                                        <mat-option [value]="project">
                                                            {{ project }}
                                                        </mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        }
                                        @case ('releaseStage') {
                                            <mat-form-field class="flex">
                                                <mat-label class="flex center no-wrap">{{ column.label }}</mat-label>
                                                <mat-select [formControl]="filter.releaseStages"
                                                            (selectionChange)="onSelectionChange()"
                                                            multiple>
                                                    @for (release of getReleases(); track release) {
                                                        <mat-option [value]="release">
                                                            {{ release.label }}
                                                        </mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        }
                                        @case ('contractType') {
                                            <mat-form-field class="flex">
                                                <mat-label class="flex center no-wrap">{{ column.label }}</mat-label>
                                                <mat-select
                                                    [formControl]="filter.contractTypes"
                                                    (selectionChange)="onSelectionChange()"
                                                    multiple>
                                                    @for (contract of getContractTypes(); track contract) {
                                                        <mat-option
                                                            [value]="contract.id">{{ contract.label }}
                                                        </mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        }
                                        @case ('buildingConsultant') {
                                            <mat-form-field class="flex">
                                                <mat-label class="flex center no-wrap">{{ column.label }}</mat-label>
                                                <mat-select
                                                    [formControl]="filter.buildingConsultants"
                                                    multiple
                                                    (selectionChange)="onSelectionChange()">
                                                    @for (option of getBuildingConsultants(); track option) {
                                                        <mat-option
                                                            [value]="option.label"
                                                        >
                                                            {{ option.label }}
                                                        </mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        }
                                        @case ('businessEntity') {
                                            <mat-form-field class="flex">
                                                <mat-label class="flex center no-wrap">{{ column.label }}</mat-label>
                                                <mat-select
                                                    [formControl]="filter.businessEntities"
                                                    multiple
                                                    (selectionChange)="onSelectionChange()">
                                                    @for (option of this.getBusinessEntitiesNames(); track option) {
                                                        <mat-option
                                                            [value]="option">{{ businessEntitiesDict[option] }}
                                                        </mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        }
                                        @case ('district') {
                                            <mat-form-field class="flex">
                                                <mat-label class="flex center no-wrap">{{ column.label }}</mat-label>
                                                <mat-select
                                                    [formControl]="filter.districts"
                                                    (selectionChange)="onDistrictChange()"
                                                    multiple>
                                                    @for (district of getDistricts(); track district) {
                                                        <mat-option
                                                            [value]="district.id">{{ district.name }}
                                                        </mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        }
                                        @case ('area') {
                                            <mat-form-field class="flex">
                                                <mat-label class="flex center no-wrap">{{ column.label }}</mat-label>
                                                <mat-select
                                                    [formControl]="filter.areas"
                                                    (selectionChange)="onSelectionChange()"
                                                    multiple>
                                                    @for (area of this.areas; track area) {
                                                        <mat-option
                                                            [value]="area.id">{{ area.name }}
                                                        </mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        }
                                        @default {
                                            {{ column.label }}
                                        }
                                    }
                                </div>
                            }
                            @case ('sortable') {
                                <div class="sortable-header flex flex-row center-center"
                                     (click)="changeSortOrder(column.key)">
                                    <div>
                                        {{ column.label }}
                                    </div>
                                    <mat-icon class="sort-arrow" [ngClass]="{ 'active': isSorted(column.key) }">
                                        {{ getSortIcon(column.key) }}
                                    </mat-icon>
                                </div>
                            }
                            @default {
                                {{ column.label }}
                            }
                        }
                    </div>
                </th>
                <td mat-cell *matCellDef="let element">
                    <div class="center">
                        @switch (column.type) {
                            @case ('date') {
                                {{ element[column.key] | date:'d MMM y' }}
                            }
                            @case ('text') {
                                <div
                                    title="{{ element[column.key] }}"
                                >
                                    {{ element[column.key] | cbTruncate:maxLength }}
                                </div>
                            }
                            @case ('custom') {
                                <div>
                                    @switch (column.key) {
                                        @case ('settlementDate') {
                                            @if (!element.editingSettlementDate) {
                                                <div
                                                    class="center editable-field editable-block"
                                                    (click)="element.editingSettlementDate = true"
                                                >
                                                    {{ element.settlementDate ? (element.settlementDate | date:'d MMM y') : 'Click to add' }}
                                                </div>
                                            } @else {
                                                <div class="center-center datePicker editable-block">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>MM/DD/YYYY</mat-label>
                                                        <input
                                                            matInput
                                                            [matDatepicker]="settlementPicker"
                                                            [(ngModel)]="element.settlementDate"
                                                            (dateChange)="onSettlementDateChange(element)"
                                                        />
                                                        <mat-datepicker-toggle matSuffix
                                                                               [for]="settlementPicker"></mat-datepicker-toggle>
                                                        <mat-datepicker #settlementPicker></mat-datepicker>
                                                    </mat-form-field>
                                                </div>
                                            }
                                        }
                                        @case ('floorDownDate') {
                                            @if (!element.editingFloorDownDate) {
                                                <div
                                                    class="center editable-field editable-block"
                                                    (click)="element.editingFloorDownDate = true"
                                                >
                                                    {{ element.floorDownDate ? (element.floorDownDate | date:'d MMM y') : 'Click to add' }}
                                                </div>
                                            } @else {
                                                <div class="center-center datePicker editable-block">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>MM/DD/YYYY</mat-label>
                                                        <input
                                                            matInput
                                                            [matDatepicker]="floorDownPicker"
                                                            [(ngModel)]="element.floorDownDate"
                                                            (dateChange)="onFloorDownDateChange(element)"
                                                        />
                                                        <mat-datepicker-toggle matSuffix
                                                                               [for]="floorDownPicker"></mat-datepicker-toggle>
                                                        <mat-datepicker #floorDownPicker></mat-datepicker>
                                                    </mat-form-field>
                                                </div>
                                            }
                                        }
                                        @case ('contractConditions') {
                                            @if (!element.editingContractConditions) {
                                                <div
                                                    class="center editable-field editable-block"
                                                    (click)="startEditingContractConditions(element)"
                                                    [title]="element.contractConditions || 'Click to add...'"
                                                >
                                                    {{ isEmpty(element.contractConditions) ? (element.contractConditions | cbTruncate: 50) : 'Click to add' }}
                                                </div>
                                            } @else {
                                                <div class="center-center editable-block">
                                                    <mat-form-field appearance="outline">
                                <textarea class="text-block"
                                          matInput
                                          [(ngModel)]="element.contractConditions"
                                          (blur)="onContractConditionsChange(element)"
                                          maxlength="300"
                                ></textarea>
                                                    </mat-form-field>
                                                </div>
                                            }
                                        }
                                        @case ('businessEntity') {
                                            <div
                                                class="center">{{ getBusinessEntitiesName(element.businessEntityId) }}
                                            </div>
                                        }
                                        @case ('jobNumber') {
                                            <div class="center">
                                                <a (click)="onJobNumberClick(element.id)"
                                                   class="job-number-link">{{ element.jobNumber }}</a>
                                            </div>
                                        }
                                        @default {
                                            Custom column for {{ column.key }} not yet implemented
                                        }
                                    }
                                </div>
                            }
                            @default {
                                {{ element[column.key] }}
                            }
                        }
                    </div>
                </td>
            </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="columnKeys; sticky:true" class="header"></tr>
        <tr mat-row *matRowDef="let row; columns: columnKeys;" (click)="onRowClick($event, row)"></tr>
    </table>
</section>
